module.exports = __webpack_public_path__ + "fonts/17cb930.otf";